module.exports = "label,\n.infoCarac {\n    color: rgb(31, 112, 191)\n}\n\n.modalclass {\n    margin-left: 20%;\n    margin-top: 100px;\n}\n\n.profilclass {\n    margin-left: 15%;\n    margin-top: 10px;\n}\n\n.infoCarac {\n    font-size: larger;\n    font-weight: 300;\n}\n\n.marginleft {\n    margin-left: 5%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/profile.component.css
// module id = ./src/app/profile/profile.component.css
// module chunks = main